var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitialBtn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 77,
    viewBox: "0 0 230 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4189_40406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.808594C0 0.808594 201.991 0.808594 207.453 0.808594C218.801 0.808594 218.801 11.5485 218.801 11.5485H10.0824C10.0824 15.4639 10.0824 52.2619 10.0824 57.5275C10.0824 63.4007 13.0253 67.1811 19.7469 67.1811C26.4685 67.1811 219.637 66.7638 219.637 66.7638V11.26C219.637 11.26 229.301 12.9416 229.301 20.0729C229.301 27.2103 229.301 76.8286 229.301 76.8286C229.301 76.4113 27.7341 76.8286 17.2279 76.8286C6.72157 76.8286 0 70.532 0 59.1968C0 49.31 0 0.808594 0 0.808594Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4189_40406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229.301,
    height: 76.02,
    fill: "white",
    transform: "translate(0 0.808594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialBtn2);
export default __webpack_public_path__ + "static/media/initial-btn-2.3648f3325423d40cfd478a89ed2d1c23.svg";
export { ForwardRef as ReactComponent };